import VisibilityToggle from './visibility-toggle';

export default class Toggle {
	constructor({ elements }) {
		elements.forEach((el) => {
			el.addEventListener('click', (e) => {
				VisibilityToggle.getElements(e, el);
			});
		});
	}
}
